import React from 'react'
import { useDarkMode } from '../../context/DarkModeContext'
import EmailSettingsModal from './EmailSettingsModal'
import { emailSettingsStyles } from './emailSettingsStyles'
import { cleanEmailHtml } from './cleanEmailHtml'

// The same sample load the extension's template preview fills in.
const SAMPLE_VALUES = {
	origin: 'Ft Atkinson, WI',
	destination: 'Rosedale, MD',
	pick_date: new Date('2025-04-29T15:00:00Z').toLocaleDateString(),
	equipment_type: 'Van',
	trip_miles: '824',
	deadhead: '24',
	reference_id: '33850755',
}

export const fillPlaceholders = text =>
	(text || '').replace(/{{(\w+)}}/g, (placeholder, name) => SAMPLE_VALUES[name] ?? placeholder)

// The template as a broker would read it, with the sample load filled in.
export const TemplatePreview = ({ subject, body, cc }) => (
	<div className="rounded-lg bg-white text-gray-900 ring-1 ring-gray-200 overflow-hidden">
		<div className="px-4 py-3 border-b border-gray-200 text-sm">
			<span className="text-gray-500">Subject: </span>
			<span className="font-medium">{fillPlaceholders(subject)}</span>
			{cc?.length > 0 && <div className="text-gray-500 mt-1">CC: {cc.join(', ')}</div>}
		</div>
		<div
			className="px-4 py-3 text-sm leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_a]:text-blue-600 [&_a]:underline [&_p]:mb-2"
			dangerouslySetInnerHTML={{ __html: cleanEmailHtml(fillPlaceholders(body)) }}
		/>
	</div>
)

const TemplatePreviewModal = ({ template, onEdit, onClose }) => {
	const { isDarkMode } = useDarkMode()
	const styles = emailSettingsStyles(!isDarkMode)

	return (
		<EmailSettingsModal
			title={template.name}
			subtitle="Preview with a sample load"
			onClose={onClose}
			footer={
				<>
					<button type="button" onClick={onClose} className={`${styles.secondaryButton} w-full sm:w-auto py-2`}>
						Close
					</button>
					<button type="button" onClick={onEdit} className={`${styles.primaryButton} w-full sm:w-auto`}>
						Edit template
					</button>
				</>
			}
		>
			<TemplatePreview subject={template.subject} body={template.body} cc={template.cc} />
		</EmailSettingsModal>
	)
}

export default TemplatePreviewModal
